import React, { useState } from 'react';
import SectionHeader from './SectionHeader';
import './Experience.css';

// Work history written as a changelog, newest release first.
const jobsData = [
  {
    version: 'v5.0',
    company: 'Google Summer of Code 2026 - Contributor@IOOS',
    title: "Google Summer of Code - Contributor@IOOS",
    range: 'May 2026 - Present · Selected',
    link: 'https://summerofcode.withgoogle.com/programs/2026/projects/oMVlDkiW',
    linkLabel: 'Read the project proposal',
    tasks: [
      'Working with NOAA / IOOS in the ocean and geospatial domain to modernize the open-source NOS Skill Assessment Package, the toolkit oceanographers use to validate operational ocean forecast models against real-world observations.',
      'Turning a powerful scientific package into a more delightful user experience through better APIs, cleaner workflows, modern tooling, and sharper documentation.',
      'Improving the developer experience so the project is welcoming to new contributors and can scale with its open-source community.',
      'Treating the engineering work as a product problem: scientists are the users, and contributor onboarding time is the key metric.',
    ],
  },
  {
    version: 'v4.0',
    company: 'Reltin by Assetary',
    title: 'Chief Product and Operations Officer',
    range: 'Aug 2025 - Present',
    link: 'https://www.reltin.com',
    linkLabel: 'Explore beta product',
    tasks: [
      'Leading product and operations for an intelligence platform that replaces information asymmetry with fact-based certainty in Indian real estate.',
      'Building the "CRISIL for Real Estate": aggregating and decoding millions of data points to reveal property backstories (debt defaults, ownership disputes, regulatory breaches) in under 30 seconds.',
      'Architecting unbiased intelligence systems that verify facts over marketing claims; no builder commissions, working solely for homebuyers.',
      'Delivering what takes lawyers 3 weeks to find, instantly: instant Property Trust Score for informed homebuying decisions.',
    ],
  },
  {
    version: 'v3.0',
    company: 'Artificial Intelligence and Robotics (AIR) Research Center',
    title: 'Full Stack Developer, AI Researcher',
    range: '2024 - Present',
    link: 'https://air.vitap.ac.in/members/tanmay.html',
    linkLabel: 'Visit team profile',
    tasks: [
      'Architected and implemented RAG (Retrieval-Augmented Generation) pipelines for SAGAR, an AI-driven marine and geospatial intelligence platform for oceanographic research.',
      'Built end-to-end systems combining AI, data engineering, and full-stack development for large-scale public infrastructure and research applications.',
      'Developed AI-powered solutions including PARAS (smart parking with predictive analytics) and SAGAR (marine intelligence), both recognized at Smart India Hackathon.',
      'Research spanning artificial intelligence, data analytics, and civic technology for real-world impact.',
    ],
  },
  {
    version: 'v2.0',
    company: 'Forest Naturals',
    title: 'Product Lead & Business Strategist',
    range: 'Nov 2024 - Mar 2025',
    tasks: [
      'Led e-commerce digital transformation for "Bastar Se Bazar Tak", increasing sales 3X through strategic product initiatives.',
      'Engineered a scalable e-commerce platform using MERN stack and an analytics dashboard for real-time sales tracking.',
      'Developed AI-driven supply chain optimization, improving logistics efficiency by 30% and reducing costs by 20%.',
      'Collaborated with cross-functional teams to align AI features with user needs, reducing implementation challenges by 30%.',
    ],
  },
  {
    version: 'v1.0',
    company: 'BorderlessPay · Independent Product Project',
    title: 'Independent Product Engineer',
    range: 'Sept 2023 - Jun 2024',
    tasks: [
      'Context: BorderlessPay was an independent project I shipped end-to-end, not a registered company or funded venture; the highlights below are from MVP-style builds, pilots, and early users, not large-scale commercial operations.',
      'Developed a blockchain-based payment platform with AI-driven fraud detection, reducing transaction errors by 20% and cutting costs by 15%.',
      'Owned end-to-end product strategy for pilots with SMBs and freelancers, growing retention among active early adopters by 40%.',
      'Implemented automated compliance checks (reduce regulatory overhead by 30%) and fraud detection algorithms using Python.',
    ],
  },
];

function Experience() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <>
      <SectionHeader index="02" label="Changelog" title="Release history" />

      <div className="changelog">
        {jobsData.map((job, index) => {
          const isOpen = openIndex === index;
          return (
            <article key={index} className={`log-entry reveal ${isOpen ? 'log-entry--open' : ''}`}>
              <button
                type="button"
                className="log-head"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
              >
                <span className="log-version">{job.version}</span>
                <span className="log-main">
                  <span className="log-role">{job.title}</span>
                  <span className="log-company">{job.company}</span>
                </span>
                <span className="log-range">{job.range}</span>
                <span className="log-toggle" aria-hidden="true">{isOpen ? '−' : '+'}</span>
              </button>

              <div className="log-body">
                <div className="log-body-inner">
                  <ul>
                    {job.tasks.map((task, i) => (
                      <li key={i}>{task}</li>
                    ))}
                  </ul>
                  {job.link && job.linkLabel && (
                    <a
                      href={job.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-ink log-link"
                    >
                      {job.linkLabel} ↗
                    </a>
                  )}
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </>
  );
}

export default Experience;
